module.exports = __webpack_public_path__ + "static/media/filter.e24e040e.svg";